<template>
    <div class="directoriesDetele">
        <div class="directories_wrap">
            <div class="directories_title">{{ listItem.monomerName }}</div>
            <div class="directories_nav">
                <div class="directories_nav_box directories_nav_one">
                    <div class="directories_nav_left">主类: </div>
                    <div class="directories_nav_right">{{ listItem.mainClassifyName }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">亚类: </div>
                    <div class="directories_nav_right">{{ listItem.subClassifyName }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">基本类型: </div>
                    <div class="directories_nav_right">{{ listItem.basicClassifyName }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">资源等级: </div>
                    <div class="directories_nav_right">{{ listItem.evaluateScoreGrade }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">所属地区: </div>
                    <div class="directories_nav_right">{{ listItem.location }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">代号: </div>
                    <div class="directories_nav_right">{{ listItem.codeNum }}</div>
                </div>
            </div>
            <div class="directories_nav  line_top1">
                <div class="directories_nav_box directories_nav_one">
                    <div class="directories_nav_left">单体保存现状: </div>
                    <div class="directories_nav_right">{{ listItem.currentSituation }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">保护措施情况: </div>
                    <div class="directories_nav_right">{{ listItem.safeguards }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">保护级别: </div>
                    <div class="directories_nav_right">{{ listItem.protectLevel }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">自然保护区级别: </div>
                    <div class="directories_nav_right">{{ listItem.natureReserve }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">开发利用程度: </div>
                    <div class="directories_nav_right">{{ listItem.useLevel }}</div>
                </div>
                <div class="directories_nav_box">
                    <div class="directories_nav_left">是否已开发: </div>
                    <div class="directories_nav_right">{{ listItem.isDeveloped }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../../service/modules/resourcesManage';

export default {
    data () {
        return {
            listItem: {}
        }
    },
    created () {
        this.getDirectoriesInfo();
    },
    methods: {
        async getDirectoriesInfo () {
            let res = await api.getDirectoriesInfo({ id: this.$route.query.id });
            if (res.ret === 0) {
                this.listItem = res.data;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.directoriesDetele {
    width: 100%;
    padding: 16px 12px;
    .directories_wrap {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        padding: 16px 0 0;
        .directories_title {
            color: #333;
            font-size: 14px;
            font-weight: bold;
            padding: 0 16px;
        }
        .directories_nav {
            padding: 16px;
            .directories_nav_box {
                color: #666666;
                font-size: 14px;
                font-weight: 400;
                margin-top: 12px;
                display: flex;
                .directories_nav_left {
                    margin-right: 12px;
                }
            }
            .directories_nav_one {
                margin-top: 0;
            }
        }
    }
}
</style>
